import { Checkbox, Form, Input } from 'antd';
import isEqual from 'lodash/isEqual';
import { Fragment, memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import handleArrowKeyNavigation from '../../handleArrowKeyNavigation';
import InputElement from './InputElement';
import useRefreshComponent from '@vindr/utils/hooks/useRefreshComponent';

export interface InputTextProps {
  disabled: boolean;
  element: InputElement;
  onChange: (val: string, element: InputElement) => void;
  index?: number;
}

const InputText = ({ disabled, element, onChange, index }: InputTextProps) => {
  const { t } = useTranslation('Vindoc');
  const [isHidden, setIsHidden] = useState(element.is_hidden);
  const [refresh, setRefresh] = useRefreshComponent();

  useEffect(() => {
    element.setIsHidden(isHidden);
    onChange(element.value, element);
    setRefresh();
  }, [element, isHidden, onChange, setRefresh]);

  return (
    <Fragment key={refresh}>
      <div key={element.id} className="flex items-start">
        <Checkbox
          checked={!isHidden}
          className="mr-2 mt-0.5"
          onChange={(e) => setIsHidden(!e.target.checked)}
        />
        <Form.Item
          label={[element?.name, index ?? ''].join(' ')}
          {...(element?.tooltip && { tooltip: { title: element?.tooltip } })}
          className="mb-3 flex-1"
        >
          <Input
            allowClear
            defaultValue={element?.value || element?.default_value || ''}
            disabled={!element?.is_editable_value || disabled}
            placeholder={t(element?.placeholder || 'Input details')}
            onChange={(e) => onChange(e.target.value, element)}
            onKeyDown={(event) => handleArrowKeyNavigation({ event, open: true })}
          />
        </Form.Item>
      </div>
    </Fragment>
  );
};

export default memo(InputText, (prev, next) => isEqual(prev.element, next.element));
